<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 7V17" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17 12H7" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
const plusIcon = {
    name: 'plusIcon',
    props: {
        color: {
            type: String,
            default: '#2168BC',
        },
    },
}
export default plusIcon
export { plusIcon }
</script>